/* BLSTR redesign — interactions. Self-contained, no dependencies. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* smooth scrolling only for in-page anchor clicks (never for restoration) */
  function smoothAnchors() {
    var reduce2 = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce2 ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + id);
    });
  }

  /* scroll reveals */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        var d = +e.target.dataset.d || 0;
        setTimeout(function () { e.target.classList.add('in'); }, Math.min(d, 600));
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
  function reveal(el) { var d = +el.dataset.d || 0; setTimeout(function () { el.classList.add('in'); }, Math.min(d, 600)); }
  /* Anything already on the first screen is revealed outright: an observer that
     never fires (hidden tab, prerender, restored scroll) must not leave hero
     copy at opacity 0. A late sweep catches anything still unrevealed in view. */
  function revealInView() {
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.95 && r.bottom > 0) reveal(el);
    });
  }
  function armReveals() {
    revealInView();
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) { io.observe(el); });
    setTimeout(revealInView, 1200);
  }

  /* before/after wipe — auto-sweep + drag, on every .ba */
  function initWipe(el) {
    var wrap = el.querySelector('.after-wrap'), handle = el.querySelector('.handle');
    if (!wrap || !handle) return;
    var pos = 0.5, auto = !reduce, t0 = performance.now(), drag = false;
    function render() { wrap.style.clipPath = 'inset(0 0 0 ' + (pos * 100) + '%)'; handle.style.left = 'calc(' + (pos * 100) + '% - 1px)'; }
    function loop(now) { if (!auto) return; pos = 0.5 + 0.36 * Math.sin((now - t0) / 2200); render(); requestAnimationFrame(loop); }
    function set(e) { var r = el.getBoundingClientRect(); var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left; pos = Math.min(.97, Math.max(.03, x / r.width)); render(); }
    el.addEventListener('pointerdown', function (e) { auto = false; drag = true; try { el.setPointerCapture(e.pointerId); } catch (_) {} set(e); });
    el.addEventListener('pointermove', function (e) { if (drag) set(e); });
    window.addEventListener('pointerup', function () { drag = false; });
    render(); if (auto) requestAnimationFrame(loop);
  }

  /* product gallery thumbs + tabs + wood project selector */
  function initInteractive() {
    var pstage = document.getElementById('pstage');
    if (pstage) {
      var thumbs = [].slice.call(document.querySelectorAll('.gthumb'));
      function show(i, fromArrow, slideDir) {
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        var t = thumbs[i]; if (!t) return;
        thumbs.forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        /* data-img is a raw Shopify CDN URL with no width param, so swapping it in loaded
           the FULL original every time (audit SPD-05). Ask the CDN for sized variants and
           hand the browser a srcset instead. Non-Shopify URLs are passed through untouched. */
        var raw = t.dataset.img || '';
        var sized = function (w) {
          if (!/\/cdn\/shop\//.test(raw)) return raw;
          return raw + (raw.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
        };
        var srcset = /\/cdn\/shop\//.test(raw)
          ? ' srcset="' + [400, 600, 900, 1200, 1600].map(function (w) {
              return sized(w) + ' ' + w + 'w';
            }).join(', ') + '" sizes="(max-width:749px) 92vw, 46vw"'
          : '';
        /* Cross-fade the swap instead of replacing the node outright. innerHTML swapping
           gave a blank frame while the new file downloaded, which read as a stutter on a
           phone. Decode first, then animate; fall back to the plain swap if anything in
           that chain is unavailable. */
        var markup = '<img src="' + sized(900) + '"' + srcset + ' style="width:100%; aspect-ratio:1/1; object-fit:contain; display:block; cursor:zoom-in;" alt="">';
        var outgoing = pstage.querySelector('img');
        var dir = (typeof slideDir === 'number' && slideDir) || 0;
        function commit() {
          pstage.innerHTML = markup;
          var im = pstage.querySelector('img');
          if (im && !reduce) {
            im.animate(
              [{ opacity: 0, transform: 'translateX(' + (dir * 26) + 'px) scale(.985)' },
               { opacity: 1, transform: 'none' }],
              { duration: 300, easing: 'cubic-bezier(.22,.9,.28,1)' });
          }
        }
        if (reduce || !outgoing || !outgoing.animate) { commit(); }
        else {
          var pre = new Image();
          pre.src = sized(900);
          var done = false;
          var go = function () {
            if (done) return; done = true;
            outgoing.animate(
              [{ opacity: 1, transform: 'none' },
               { opacity: 0, transform: 'translateX(' + (-dir * 26) + 'px) scale(.985)' }],
              { duration: 150, easing: 'cubic-bezier(.4,0,1,1)' }).onfinish = commit;
          };
          /* never wait on the network for longer than a frame budget */
          (pre.decode ? pre.decode().then(go, go) : Promise.resolve().then(go));
          setTimeout(go, 220);
        }
        var wb = document.querySelector('.watchbtn');
        if (wb) { wb.style.display = ''; wb.setAttribute('aria-pressed', 'false'); }
        /* Keep the newly-active thumb in the horizontal strip WITHOUT touching the page
           scroll. `scrollIntoView` walks every scrollable ancestor including the document,
           so pressing an arrow at the top of the page nudged the whole page down - the
           sticky nav overlaps the strip, so the browser judged it "not visible" even when
           it plainly was. Scroll the strip itself and nothing else. */
        if (fromArrow) {
          var strip = t.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth + 1) {
            var l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth, pad = 8;
            if (l < strip.scrollLeft) strip.scrollLeft = Math.max(0, l - pad);
            else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth + pad;
          }
        }
      }
      function current() { var i = thumbs.findIndex(function (x) { return x.classList.contains('active'); }); return i < 0 ? 0 : i; }

      /* ---- autoplay: removed -----------------------------------------------------
         The stage used to advance every 5s. Two measured reasons it is gone:
           - the page never became visually stable, so Speed Index sat at ~22s and scored
             zero. With the 5s timer suppressed: SI 22s -> 4.4s, +6 Lighthouse points.
           - every visitor pulled all seven photos (~642KB over one 48s cycle) whether they
             looked at the gallery or not. The other six are now fetched only on request.
         Mainstream Shopify themes (Dawn, Impulse, Prestige) do not auto-rotate product
         media either: it moves the thing the customer is deliberately examining, and on a
         phone there was no discoverable way to stop it - the pause handlers were
         pointerenter/pointerleave/focusin, none of which fire on touch.
         Thumbnails, arrows, keyboard, swipe and click-to-zoom are all unchanged.
         galleryTakeOver() stays as a no-op so its seven call sites need no edit. ------- */
      function galleryTakeOver() {}
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { galleryTakeOver(); show(i); }); });

      /* desktop prev/next arrows over the stage */
      if (thumbs.length > 1) {
        var wrap = pstage.parentElement;
        ['prev', 'next'].forEach(function (dir) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'gnav gnav-' + dir;
          b.setAttribute('aria-label', dir === 'prev' ? 'Previous image' : 'Next image');
          b.innerHTML = dir === 'prev' ? '&#8249;' : '&#8250;';
          b.addEventListener('click', function (e) { e.stopPropagation(); galleryTakeOver(); show(current() + (dir === 'next' ? 1 : -1), true, dir === 'next' ? 1 : -1); });
          wrap.appendChild(b);
        });
        wrap.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { galleryTakeOver(); show(current() - 1, true, -1); }
          else if (e.key === 'ArrowRight') { galleryTakeOver(); show(current() + 1, true, 1); }
        });
        wrap.setAttribute('tabindex', '0');
      }

      /* Swipe the stage between images. The image now follows the finger and either
         completes or springs back on release; before, nothing moved until the gesture
         ended, so a swipe felt like a button press with a delay. */
      (function () {
        var sx = 0, sy = 0, tracking = false, dragging = false, img = null, w = 1;
        function shift(dx, fade) {
          if (!img) return;
          img.style.transform = 'translateX(' + dx + 'px)';
          img.style.opacity = fade;
        }
        function release(reset) {
          if (!img) return;
          var el = img; img = null;
          if (reset && el.animate && !reduce) {
            el.animate([{ transform: el.style.transform, opacity: el.style.opacity },
                        { transform: 'none', opacity: 1 }],
                       { duration: 260, easing: 'cubic-bezier(.22,1.2,.36,1)' })
              .onfinish = function () { el.style.transform = ''; el.style.opacity = ''; };
          } else { el.style.transform = ''; el.style.opacity = ''; }
        }
        pstage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          tracking = true; dragging = false;
          sx = e.touches[0].clientX; sy = e.touches[0].clientY;
          img = pstage.querySelector('img');
          w = pstage.getBoundingClientRect().width || 1;
          if (img) img.style.transition = 'none';
        }, { passive: true });
        pstage.addEventListener('touchmove', function (e) {
          if (!tracking || e.touches.length !== 1) return;
          var dx = e.touches[0].clientX - sx, dy = e.touches[0].clientY - sy;
          if (!dragging) {
            if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) return;
            dragging = true; galleryTakeOver();
          }
          e.preventDefault();                    /* now the gesture is ours, not the page's */
          /* resistance past a third of the stage keeps the drag from running off */
          var travel = dx * (Math.abs(dx) > w / 3 ? 0.45 : 0.85);
          shift(travel, Math.max(0.35, 1 - Math.abs(dx) / w));
        }, { passive: false });
        pstage.addEventListener('touchend', function (e) {
          if (!tracking) return; tracking = false;
          var t2 = e.changedTouches[0], dx = t2.clientX - sx, dy = t2.clientY - sy;
          var commit = Math.abs(dx) > Math.min(70, w * 0.18) && Math.abs(dx) > Math.abs(dy);
          if (dragging) e.preventDefault();      /* do not also fire the zoom click */
          release(!commit);
          if (commit) { galleryTakeOver(); show(current() + (dx < 0 ? 1 : -1), true, dx < 0 ? 1 : -1); }
          dragging = false;
        }, { passive: false });
        pstage.addEventListener('touchcancel', function () {
          tracking = false; dragging = false; release(true);
        }, { passive: true });
      })();

      /* click the stage image to open it full size */
      pstage.style.cursor = 'zoom-in';
      pstage.addEventListener('click', function () {
        var im = pstage.querySelector('img'); if (!im) return;
        galleryTakeOver();   /* video slide: leave it alone */
        if (typeof window.blstrOpenImage === 'function') {
          /* hand over every thumb so the overlay can be swiped / arrowed through */
          var items = thumbs.map(function (t) { return { src: t.dataset.img, alt: t.dataset.alt || '' }; });
          window.blstrOpenImage(im.currentSrc || im.src, im.alt, items.length ? items : null, current());
          return;
        }
        var lb = document.querySelector('.blstr-imglb');
        if (!lb) return;
        lb.querySelector('img').src = im.currentSrc || im.src;
        lb.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
      });
      var first = pstage.querySelector('img'); if (first) first.style.cursor = 'zoom-in';
    }
    document.querySelectorAll('.ptab').forEach(function (b) {
      b.addEventListener('click', function () {
        document.querySelectorAll('.ptab').forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        document.querySelectorAll('.ppanel').forEach(function (p) { p.classList.toggle('on', p.dataset.panel === b.dataset.p); });
      });
    });
    document.querySelectorAll('.proj').forEach(function (t) {
      t.addEventListener('click', function () {
        document.querySelectorAll('.proj').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
        var wipe = document.getElementById('stage-wipe'), img = document.getElementById('stage-img');
        if (!wipe || !img) return;
        if (t.dataset.pair) { wipe.style.display = ''; img.style.display = 'none'; }
        else { wipe.style.display = 'none'; img.style.display = 'block'; img.src = t.dataset.src; }
      });
    });
  }


  /* The locale root, handed over by Liquid (see layout/blstr.liquid). Always ends
     in a slash: '/' in English, '/nl/' in Dutch. Every store path below is built
     from it, or a click on a localized page navigates back to English. */
  var ROOT = (window.BLSTR_ROOT || '/');
  /* ROOT is '/' or '/nl' — no trailing slash on a localized root, so add one. */
  function storeUrl(path) {
    var r = ROOT.charAt(ROOT.length - 1) === '/' ? ROOT : ROOT + '/';
    return r + String(path).replace(/^\/+/, '');
  }

  /* Shopify holds the storefront locale server-side. Navigating to /<code>/... by hand
     only rewrites the address bar, so the server's idea of the locale never moves and it
     is free to redirect the visitor straight back — which is what happened once Weglot
     stopped serving these paths. Submit the localization form instead and follow its
     redirect. `_method=put` is required; without it the endpoint 404s. */
  function switchLocale(code, returnTo) {
    var f = document.createElement('form');
    f.method = 'POST';
    f.action = storeUrl('localization');
    f.acceptCharset = 'UTF-8';
    f.hidden = true;
    var fields = { form_type: 'localization', utf8: '\u2713', _method: 'put',
                   locale_code: code, return_to: returnTo };
    Object.keys(fields).forEach(function (k) {
      var i = document.createElement('input');
      i.type = 'hidden'; i.name = k; i.value = fields[k];
      f.appendChild(i);
    });
    document.body.appendChild(f);
    f.submit();
  }

  function initLang() {
    function current() {
      var m = location.pathname.match(/^\/(nl|de|fr|it)(\/|$)/);
      return m ? m[1] : 'en';
    }
    var NAMES = { en: 'English', nl: 'Nederlands', de: 'Deutsch', fr: 'Fran\u00e7ais', it: 'Italiano' };
    var FLAGS = { en: '\uD83C\uDDEC\uD83C\uDDE7', nl: '\uD83C\uDDF3\uD83C\uDDF1', de: '\uD83C\uDDE9\uD83C\uDDEA', fr: '\uD83C\uDDEB\uD83C\uDDF7', it: '\uD83C\uDDEE\uD83C\uDDF9' };
    function paint() {
      var c = current();
      /* the header is tight so it shows the code; the drawer has room for the name */
      document.querySelectorAll('.blstr-lang-cur').forEach(function (el) {
        el.textContent = el.closest('.blstr-drawer') ? (NAMES[c] || c.toUpperCase()) : c.toUpperCase();
      });
      document.querySelectorAll('.blstr-lang-flag').forEach(function (el) { if (FLAGS[c]) el.textContent = FLAGS[c]; });
      document.querySelectorAll('.blstr-lang-menu [data-lang]').forEach(function (b) {
        b.setAttribute('aria-current', b.getAttribute('data-lang') === c ? 'true' : 'false');
      });
    }
    document.querySelectorAll('.wg-mount').forEach(function (mount) {
      var btn = mount.querySelector('.blstr-lang'), menu = mount.querySelector('.blstr-lang-menu');
      if (!btn || !menu) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !menu.hasAttribute('hidden');
        if (open) { menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); }
        else { menu.removeAttribute('hidden'); btn.setAttribute('aria-expanded', 'true'); }
      });
      menu.addEventListener('click', function (e) {
        var b = e.target.closest('[data-lang]'); if (!b) return;
        var code = b.getAttribute('data-lang');
        menu.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false');
        if (code === current()) return;
        /* return_to is the path WITHOUT a locale prefix - Shopify adds the right one */
        var path = location.pathname.replace(/^\/(nl|de|fr|it)(?=\/|$)/, '') || '/';
        switchLocale(code, path + location.search);
      });
    });
    document.addEventListener('click', function (e) {
      /* Click-outside closes the menu - but a click INSIDE it used to close it too.
         The language buttons survived because their own handler navigates away; the
         "Deliver to" row did not. It is a transparent native <select>, and closing the
         menu unmounted it before its option list could be used, so the whole panel
         appeared to vanish the moment you reached for the country. */
      if (e.target && e.target.closest && e.target.closest('.wg-mount')) return;
      document.querySelectorAll('.blstr-lang-menu').forEach(function (m) { m.setAttribute('hidden', ''); });
      document.querySelectorAll('.blstr-lang').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.blstr-lang-menu').forEach(function (m) { m.setAttribute('hidden', ''); });
    });
    paint();
  }
  /* header CTA on the product page proxies the buy box, so the selected kit is used */
  function initAtcProxy() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-atc-proxy]'); if (!b) return;
      e.preventDefault();
      var real = document.getElementById('atcBtn');
      if (real) { real.click(); return; }
      window.location.href = storeUrl('products/blstr-sander');
    });
  }

  /* sticky buy bar. Trigger off the buy button leaving the viewport, not a fixed
     scroll depth: at 720px the bar appeared while the buy box was still on screen,
     stacking the same price three times in one viewport (kit card + ATC + bar). */
  function initBuyBar() {
    var bar = document.querySelector('.blstr-buybar'); if (!bar) return;
    var atc = document.getElementById('atcBtn');
    window.addEventListener('scroll', function () {
      var past = atc ? atc.getBoundingClientRect().bottom < 0 : window.scrollY > 720;
      bar.classList.toggle('show', past);
    }, { passive: true });
  }

  /* mobile nav drawer */
  function initNav() {
    var drawer = document.getElementById('blstrDrawer');
    if (!drawer) return;
    var burgers = document.querySelectorAll('.blstr-nav .burger');
    function open() {
      drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('blstr-noscroll');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    }
    function close() {
      drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('blstr-noscroll');
      burgers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    burgers.forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-close]').forEach(function (el) { el.addEventListener('click', close); });
    drawer.querySelectorAll('.blstr-drawer-links a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });
  }

  /* add-to-cart (kits / buy bar) */
  /* Machine buy buttons (data-checkout) skip the cart page: 6 in 10 cart visitors never
     reached checkout after the redesign (in-app mobile: 7 in 10), the old theme went
     straight there. The free bag is added by the BOGOS app, which wraps fetch on every page
     and attaches the bag ~0.2 s after cart/add.js (verified live 2026-09-29) - wait for that
     line so the warehouse gets it, then go. Accessory buttons keep the cart page. */
  var FREE_BAG_VARIANT = 55562584359247;
  function gotoCheckout() {
    var tries = 0;
    (function poll() {
      fetch(storeUrl('cart.js')).then(function (r) { return r.json(); }).then(function (c) {
        /* present AND already zeroed by the app's 100%-off code - the line arrives first,
           the discount a moment later, and checkout would price the bag at €39 in between */
        var bagFree = c.items.some(function (it) { return it.variant_id === FREE_BAG_VARIANT && it.final_line_price === 0; });
        if (bagFree || ++tries >= 12) { window.location.href = storeUrl('checkout'); return; }
        setTimeout(poll, 250);
      }).catch(function () { window.location.href = storeUrl('checkout'); });
    })();
  }

  function initCart() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-variants]');
      if (!b) return;
      /* .kit rows carry data-variants so pickKit() can update the price/button. They are
         SELECTORS, not triggers - adding to cart on click sent people straight to /cart
         as soon as they picked a different kit. Only real buttons trigger the add. */
      if (b.classList.contains('kit')) return;
      var vids = (b.dataset.variants || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!vids.length) return;
      e.preventDefault();
      var items = vids.map(function (tok) { var p = tok.split(':'); return { id: parseInt(p[0], 10), quantity: p[1] ? parseInt(p[1], 10) : 1 }; });
      /* one add per tap: on a slow in-app browser the silent 1-2s wait made people
         tap again, and the second POST doubled the cart (2 machines). Ignore re-taps
         while the first is in flight, and show "Adding\u2026" so nobody feels the need. */
      if (b.dataset.busy) return;
      b.dataset.busy = '1';
      var stay = b.hasAttribute('data-stay');
      var label = stay ? b.textContent : null;
      /* the two transient states are the last English literals in this file; the layout
         hands them over already translated */
      var S = (window.BLSTR_STRINGS || {});
      b.textContent = S.adding || 'Adding\u2026';
      fetch(storeUrl('cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (b.hasAttribute('data-checkout')) { gotoCheckout(); return; }
          if (!stay) { window.location.href = storeUrl('cart'); return; }
          /* stay on the page: confirm on the button and refresh the header count */
          delete b.dataset.busy;
          b.textContent = S.added || 'Added \u2713';
          setTimeout(function () { b.textContent = label; }, 1800);
          fetch(storeUrl('cart.js')).then(function (r) { return r.json(); }).then(function (c) {
            /* NEVER set textContent on the anchor itself - it holds the <svg> icon and the
               count badge as element children, and assigning text wiped them both. */
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = c.item_count;
            });
            document.querySelectorAll('.blstr-nav .cart').forEach(function (el) {
              el.classList.toggle('has-items', c.item_count > 0);
            });
          }).catch(function () {});
        })
        .catch(function () {
          if (stay) { delete b.dataset.busy; b.textContent = label; return; }
          window.location.href = storeUrl('cart');
        });
    });
  }

  /* ---- "the full story" folds ----
     The toggle used to be an inline onclick that wrote the labels "The full story" and
     "Less" as English literals, so on a translated page the button flipped to English the
     moment it was pressed. The labels come from the markup now, already translated. */
  function initFolds() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-fold]'); if (!b) return;
      var panel = document.getElementById(b.dataset.fold); if (!panel) return;
      var open = b.classList.toggle('open');
      panel.classList.toggle('open', open);
      var lab = b.querySelector('.label');
      if (lab) lab.textContent = open ? (b.dataset.labelLess || lab.textContent)
                                      : (b.dataset.labelMore || lab.textContent);
    });
  }

  /* ---- decorative videos open full size ----
     Every autoplaying clip on the site is a muted, cover-cropped, controls-free preview.
     Clicking one did nothing, so the detail people actually wanted to see was unreachable.
     Tiles inside .u27 already have the gallery lightbox from the layout; everything else
     gets the media lightbox. */
  function initVideoZoom() {
    [].slice.call(document.querySelectorAll('.blstr video')).forEach(function (v) {
      if (v.controls || v.closest('.u27') || v.closest('.blstr-lb') || v.dataset.zoom) return;
      var src = v.currentSrc || v.getAttribute('src') ||
                (v.querySelector('source') && v.querySelector('source').getAttribute('src')) || '';
      if (!src) return;
      v.dataset.zoom = '1';
      v.style.cursor = 'zoom-in';
      var box = v.parentElement;
      if (box && !box.querySelector('.vidzoom')) {
        box.style.position = box.style.position || 'relative';
        var hint = document.createElement('span');
        hint.className = 'vidzoom';
        hint.setAttribute('aria-hidden', 'true');
        hint.textContent = '\u25B6';
        box.appendChild(hint);
      }
      v.addEventListener('click', function () {
        window.blstrOpenMedia({ src: v.currentSrc || src, caption: v.getAttribute('aria-label') || '' });
      });
    });
  }

  /* ---- FAQ accordions open and close with a real transition ----
     <details> toggles instantly, and a closed one renders nothing, so there is no start
     frame to animate from. The element is therefore left natively open once this runs and
     the state moves to a class; the answer is wrapped in a grid row that the stylesheet
     animates. Opening one question closes its siblings, which is what an accordion means. */
  function initFaq() {
    var all = [].slice.call(document.querySelectorAll('details.faq'));
    if (!all.length) return;
    all.forEach(function (d) {
      if (d.dataset.anim) return;
      var ans = d.querySelector('.ans');
      var sum = d.querySelector('summary');
      if (!ans || !sum || ans.parentElement !== d) return;
      var wrap = document.createElement('div');
      wrap.className = 'answrap';
      d.insertBefore(wrap, ans);
      wrap.appendChild(ans);
      var startOpen = d.hasAttribute('open');
      d.dataset.anim = '1';
      d.open = true;                       /* stays open natively; .is-open is the real state */
      d.classList.toggle('is-open', startOpen);
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !d.classList.contains('is-open');
        if (opening) {
          var p = d.parentElement;
          if (p) [].slice.call(p.children).forEach(function (c) {
            if (c !== d && c.classList && c.classList.contains('is-open')) c.classList.remove('is-open');
          });
        }
        d.classList.toggle('is-open', opening);
      });
    });
  }

  function boot() {
    armReveals();
    initFaq();
    initFolds();
    initVideoZoom();
    smoothAnchors();
    document.querySelectorAll('.ba').forEach(initWipe);
    initInteractive(); initBuyBar(); initNav(); initLang(); initCart(); initAtcProxy();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);

  /* globals referenced by inline onclick in sections */
  window.pickKit = function (el) {
    document.querySelectorAll('.kit').forEach(function (k) { k.classList.remove('active'); });
    el.classList.add('active');
    var price = el.dataset.price, name = el.dataset.name, vid = el.dataset.variants || '';
    /* price already arrives as a formatted money string from Liquid (currency + VAT aware),
       and the label comes from a theme setting so Weglot can translate it */
    var atc = document.getElementById('atcBtn');
    if (atc) { atc.textContent = (atc.dataset.label || atc.textContent.split('\u00b7')[0].trim()) + ' \u00b7 ' + price; atc.dataset.variants = vid; }
    var bp = document.getElementById('barPrice'); if (bp) bp.textContent = price;
    var bn = document.getElementById('barName'); if (bn) bn.textContent = name;
    var bb = document.getElementById('barBtn'); if (bb) bb.dataset.variants = vid;
  };
  /* ---- media lightbox: one overlay for YouTube embeds and for mp4 files ----
     The product video used to replace the gallery image in place, which meant a 1:1 crop of
     a 16:9 film and no way back to the photos. It opens over the page now. */
  var mediaLb = null;
  function buildMediaLb() {
    if (mediaLb) return mediaLb;
    var lb = document.createElement('div');
    lb.className = 'blstr-lb blstr-medialb';
    lb.setAttribute('hidden', '');
    lb.innerHTML = '<button class="blstr-lb-x" aria-label="Close">&times;</button>' +
      '<div class="blstr-lb-stage"><div class="blstr-lb-slot"></div>' +
      '<div class="blstr-lb-cap"></div></div>';
    document.body.appendChild(lb);
    function close() {
      lb.setAttribute('hidden', '');
      /* clearing the slot is what actually stops a YouTube iframe; pausing does not */
      lb.querySelector('.blstr-lb-slot').innerHTML = '';
      document.documentElement.style.overflow = '';
    }
    lb.querySelector('.blstr-lb-x').addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.hasAttribute('hidden') && e.key === 'Escape') close();
    });
    mediaLb = { el: lb, close: close };
    return mediaLb;
  }
  function youtubeId(u) {
    if (!u) return '';
    u = String(u).trim();
    if (u.indexOf('watch?v=') > -1) return u.split('watch?v=')[1].split('&')[0];
    if (u.indexOf('youtu.be/') > -1) return u.split('youtu.be/')[1].split('?')[0];
    if (u.indexOf('/embed/') > -1) return u.split('/embed/')[1].split('?')[0];
    if (/^[\w-]{6,20}$/.test(u)) return u;          /* a bare id */
    return '';
  }
  window.blstrOpenMedia = function (opts) {
    opts = opts || {};
    var m = buildMediaLb(), slot = m.el.querySelector('.blstr-lb-slot');
    var yid = youtubeId(opts.youtube);
    if (yid) {
      slot.innerHTML = '<div class="blstr-lb-yt"><iframe src="https://www.youtube.com/embed/' +
        yid + '?rel=0&autoplay=1" title="" allow="accelerometer; autoplay; clipboard-write; ' +
        'encrypted-media; picture-in-picture" allowfullscreen></iframe></div>';
    } else if (opts.src) {
      slot.innerHTML = '<video controls playsinline autoplay preload="metadata" src="' +
        opts.src.replace(/"/g, '&quot;') + '"></video>';
    } else {
      return;
    }
    var cap = m.el.querySelector('.blstr-lb-cap');
    cap.textContent = opts.caption || '';
    cap.style.display = opts.caption ? '' : 'none';
    m.el.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
  };
  /* the watch-video button, and anything else marked up the same way */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-media-lb]'); if (!b) return;
    e.preventDefault();
    window.blstrOpenMedia({ youtube: b.dataset.yt, src: b.dataset.video, caption: b.dataset.caption });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var b = e.target && e.target.closest && e.target.closest('[data-media-lb]'); if (!b) return;
    e.preventDefault();
    window.blstrOpenMedia({ youtube: b.dataset.yt, src: b.dataset.video, caption: b.dataset.caption });
  });
  /* kept because older cached markup still calls it by name from an inline onclick */
  window.playProductVideo = function (btn) {
    window.blstrOpenMedia({ youtube: btn.dataset.yt, src: btn.dataset.video });
  };
  window.toggleSelect = function (el) {
    var p = el.parentElement; if (p) p.querySelectorAll('.fchip').forEach(function (x) { x.classList.remove('on'); });
    el.classList.add('on');
  };
})();
